import React, { useState, useEffect, useRef } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import MCSSpace from '../../../components/MCSSpace';
import { adminService } from '../../../services/admin.service';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import "./AnnouncementDialog.css"
import { ObjectMapHelper } from '../../../_helpers/ObjectMapHelper';
import { updateAnnouncementDto } from '../../../_mappings/Announcement';
import AnnouncementDetailsInput from './Components/AnnouncementDetailsInput'
import { FormErrorMessages } from '../../../_constants/FormErrorMessages';

const ManageAnnouncementDialog = (props) => {

    const [loading, setLoading] = useState(false);
    const editorRef = useRef(null);

    const [isEmptyAnnouncementDetails, setIsEmptyAnnouncementDetails] = useState(false);
    const [invalidStartDateErrorText, setInvalidStartDateErrorText] = useState("");
    const [invalidEndDateErrorText, setInvalidEndDateErrorText] = useState("");
    const [isAnnouncementNameValid, setAnnouncementNameValid] = useState(true);

    const formReset = (isRefresh = true) => {
        if(isRefresh){
            props.tablesRefresh();
        }
        setIsEmptyAnnouncementDetails(false);
        setInvalidEndDateErrorText("");
        setInvalidStartDateErrorText("");
        setAnnouncementNameValid(true);
        props.setSelectedAnnouncementDto(null)
    }

    const checkFormValid = () => {
        let announcement = props.selectedAnnouncementDto

        if (announcement.announcementName == null || announcement.announcementName.trim().length <= 0) {
            setAnnouncementNameValid(false);
            return false;
        }

        if (announcement.startDate == null && announcement.publishState == true) {
            setInvalidStartDateErrorText(FormErrorMessages.FieldCannotBeBlank);
            return false;
        }

        return true
    }

    const updateAnnouncementDetails = async () => {
        setLoading(true)

        if (!checkFormValid()) {
            setLoading(false);
            return;
        }

        let announcement = props.selectedAnnouncementDto
        let mappedDto = ObjectMapHelper.MapDto(announcement, updateAnnouncementDto)

        if (announcement.publishState != true) {
            mappedDto.startDate = new Date(0);
        }
        mappedDto.endDate = announcement.endDate;
        mappedDto.announcementName = announcement.announcementName;

        if (editorRef.current) {
            if (editorRef.current.getContent().length == 0) {
                setIsEmptyAnnouncementDetails(true);
                setLoading(false);
                return;
            }
            mappedDto.announcementDetails = editorRef.current.getContent();
        }

        
        const Response = await adminService.UpdateAnnouncement(announcement.id, mappedDto);

        if (Response) {
            props.alertObj.setSuccessMessage("Announcement successfully updated");
        } else {
            const errorMessage = Response?.error?.message || "Unknown error occurred";
            props.alertObj.setErrorMessage("Announcement failed to be updated: " + errorMessage);
        }

        setLoading(false)
        formReset();
    }

    const deleteAnnouncement = async () => {
        setLoading(true)
        const Response = await adminService.DeleteAnnouncement(props.selectedAnnouncementDto.id);

        if (Response.success) {
            props.alertObj.setSuccessMessage("Announcement successfully deleted");
        } else {
            props.alertObj.setErrorMessage("Announcement failed to be deleted: " + Response.error.message);
        }

        setLoading(false)
        formReset();
    }
    return (
        <>
            {loading &&
                <MCSOverlayLoading />}
            <Dialog
                aria-describedby="Edit Announcement"
                onExit={() => { }}
                open={props.openAnnouncementDialog}
                titleId="dialog-manage-announcement"
            >
                <DialogCardHead style={{height:"25px"}}>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Edit Announcement</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-description-manage-file-field">
                    <AnnouncementDetailsInput announcementDto={props.selectedAnnouncementDto} setAnnouncementDto={props.setSelectedAnnouncementDto}
                        editorRef={editorRef} invalidStartDateErrorText={invalidStartDateErrorText}
                        invalidEndDateErrorText={invalidEndDateErrorText} setInvalidStartDateErrorText={setInvalidStartDateErrorText}
                        setInvalidEndDateErrorText={setInvalidEndDateErrorText} isAnnouncementNameValid={isAnnouncementNameValid}
                        setAnnouncementNameValid={setAnnouncementNameValid} isEmptyAnnouncementDetails={isEmptyAnnouncementDetails}/>
                </DialogCardBody>
                <MCSSpace />

                <DialogCardFooter>

                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                formReset(false)
                            }}
                        > Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                updateAnnouncementDetails()
                            }}
                        > Save
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                let result = window.confirm("Are you sure you want to delete this announcement?");
                                if (result) {
                                    deleteAnnouncement()
                                }
                            }}
                        > Delete
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default ManageAnnouncementDialog
